import { render, staticRenderFns } from "./finishPrice.vue?vue&type=template&id=74cc995c&scoped=true&"
import script from "./finishPrice.vue?vue&type=script&lang=js&"
export * from "./finishPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc995c",
  null
  
)

export default component.exports